import React from 'react';
import NewLayout from "../layout/newLayout"
import styles from '../styles/scss/pages/page.module.scss'
import PageContents from '../components/pageContents'
import SEO from "../components/seo"
import HeroSimple from '../components/heroSimple';

const Page = ({ pageContext }) => {
  const page = pageContext.page;
  const hasNewHero = page && page.heroDesktop && page.heroMobile;
  const hasLegacyHero = page && page.heroImage && page.heroImage.url;
  const heroTitle =
    (page && page.heroDesktop && page.heroDesktop.title) ||
    (page && page.heroImage && page.heroImage.title) ||
    page.title ||
    'WD40 Hero';

  return (
    <NewLayout>
      <h1 style={{ display: 'none' }}>{(page && page.seo && page.seo.title) || (page && page.title) || 'Home page'}</h1>
      <SEO page={page} />
      {hasNewHero && (
        <HeroSimple
          style={{ marginBottom: '10px' }}
          isnew="true"
          image={page.heroDesktop.url}
          mobileimage={page.heroMobile.url}
          title={heroTitle}
        />
      )}
      {!hasNewHero && hasLegacyHero && (
        <HeroSimple
          style={{ marginBottom: '10px' }}
          image={page.heroImage.url}
          title={heroTitle}
        />
      )}
      <div className='d-flex flex-column flex-fill'>
        <div className={styles.containerColumn}>
          <PageContents content={page.content} />
        </div>
      </div>
    </NewLayout>
  )
}

export default Page;